import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// Material
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTableModule } from "@angular/material/table";
import { MatDialogModule } from "@angular/material/dialog";

// Translate
import { TranslateModule } from "@ngx-translate/core";

// Form controls (empleado autocomplete)
import { FormControlsModule } from "../form-controls/form-controls.module";
import { NameCasePipe } from "src/app/_core/pipes/name-case.pipe";
import { EmptyStateComponent } from "src/app/_core/components/empty-state/empty-state.component";
import { DsSortTableDirective } from "src/app/_core/directives/ds-sort-table.directive";

// Components
import { EntityContactsTabComponent } from "./components/entity-contacts-tab/entity-contacts-tab.component";
import { ContactDialogComponent } from "./components/contact-dialog/contact-dialog.component";

/**
 * Módulo compartido para componentes de contactos sin routing
 * Para usar en otros módulos sin conflictos de routing
 */
@NgModule({
	declarations: [
		EntityContactsTabComponent,
		ContactDialogComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		MatTableModule,
		MatDialogModule,
		TranslateModule,
		FormControlsModule,
		NameCasePipe,
		EmptyStateComponent,
		DsSortTableDirective,
	],
	exports: [EntityContactsTabComponent],
})
export class SharedContactsModule {}
